import { render, staticRenderFns } from "./PostManage.vue?vue&type=template&id=3945ddc3&scoped=true&"
import script from "./PostManage.vue?vue&type=script&lang=js&"
export * from "./PostManage.vue?vue&type=script&lang=js&"
import style0 from "./PostManage.vue?vue&type=style&index=0&id=3945ddc3&scoped=true&lang=css&"
import style1 from "./PostManage.vue?vue&type=style&index=1&id=3945ddc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3945ddc3",
  null
  
)

export default component.exports